import React, { useState, useMemo, useEffect, useCallback, useContext } from "react";
import Layout from "../../Layout";
import SpaceCategoriesPaths from "./SpaceCategoriesPaths";
import Sidebar from "./sidebar";
import PageList from "./PageList";
import GroupCollapsePanel from "./GroupFTPCollapsePanel";
import UploadDrag from "../../components/UploadDragger";
import { PermissionEnum } from "../../const";
import "../../common/index.less";
import "./index.less";
import MoveDragger from "../../components/MoveDragger";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";
import { PageRouteName } from "../../batchOperate";
import events from "../../context/events";
let folderMap: any = {};
const getFolderInfo = (id: string) => {
  if (!id) return null;
  return folderMap[id] || null;
};
export default function Group(props: any) {
  const { gname, gid, categoryId } = props;
  console.log(props, "Group====>");
  const { onLine } = useContext(GlobalContext);

  const [folder, setFolder] = useState<any>({ id: gid || "", name: gname || "" });

  useEffect(() => {
    setFolder({ id: categoryId || gid, name: gname }); // 大搜跳组空间时，要有文件夹id和gid
    events.emit("groupspace.setSearchFolderId", categoryId || gid);
  }, [categoryId, gid, gname]);

  useEffect(() => {
    folderMap = {};
  }, []);

  useEffect(() => {
    events.on("groupspace.setPageListFolder", setFolder);
    return () => {
      events.off("groupspace.setPageListFolder", setFolder);
    };
  }, []);

  const usePageList = useMemo(() => {
    return (
      <PageList
        folderName={folder?.name || gname}
        folderId={folder?.id || gid}
        setFolder={setFolder}
        folderMap={folderMap}
        gname={gname}
        gid={gid}
      />
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder, gid, gname]);
  return (
    <div
      className="joyspace groupspace"
      onClick={() => {
        events.emit("hideContextMenus");
      }}
    >
      <MoveDragger getFolderInfo={getFolderInfo} />
      <div className="joyspace-main">
        <Layout>
          <div className="joyspace-drop">
            <UploadDrag
              gid={gid}
              toId={folder?.id || gid}
              toName={folder?.name || gname}
              from={PageRouteName.GROUP}
              permissions={folder?.permissions || [PermissionEnum.PAGE_CREATE]}
            />
            <div className="joyspace-header">
              {/* 组空间面包屑 */}
              <Layout.Breadcrumbs>
                <SpaceCategoriesPaths folderId={folder?.id} setFolder={setFolder} gname={gname} />
              </Layout.Breadcrumbs>
              <Sidebar
                folderId={folder?.id || gid}
                gid={gid}
                disabledCreateFolder={gid && onLine}
              />
            </div>
            {/* 组空间列表 */}
            <div className="myspace-list-wrap">{usePageList}</div>
            {/* 组空间上传下载面板 */}
            <GroupCollapsePanel gid={gid} />
          </div>
        </Layout>
      </div>
    </div>
  );
}
